module.exports = __webpack_public_path__ + "img/wx.989acafc.jpg";